import React from "react";
import { observable } from "mobx";
import { observer } from "mobx-react";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import PrimaryButton from "@components/buttons/PrimaryButton";
import RegularButton from "@components/buttons/RegularButton";
import locale from "@bonliva-crm/locale";
import { CallListType } from "@graphql";
import { CallListEditorStore } from "./CallListEditorStore";
import { CallListEditor, CallListEditorProps } from "./CallListEditor";

type Props = CallListEditorProps & {
  open: boolean;
  listType: CallListType;
  onClose: (e: React.SyntheticEvent<any>) => void;
};

@observer
class CallListEditorDialog extends React.Component<Props> {
  @observable store = new CallListEditorStore(this.props);

  componentDidUpdate(prevProps: Readonly<Props>): void {
    if (prevProps.id !== this.props.id || prevProps.listType !== this.props.listType) {
      this.store = new CallListEditorStore(this.props);
    }
  }

  render() {
    return (
      <Dialog
        open={this.props.open}
        TransitionProps={{ mountOnEnter: true, unmountOnExit: true }}
        data-test="CallListEditorDialog"
        onBackdropClick={this.props.onClose}
      >
        <DialogTitle>{this.store.isNew ? locale.AddList : locale.EditList}</DialogTitle>

        <DialogContent>
          <CallListEditor
            id={this.props.id}
            node={this.props.node}
            onClose={this.props.onClose}
            type={this.props.type}
            store={this.store}
            listType={this.props.listType}
            onAdded={this.props.onAdded}
          />
        </DialogContent>

        <DialogActions style={{ justifyContent: "space-between" }}>
          <RegularButton onClick={this.props.onClose}>{locale.Cancel}</RegularButton>

          <PrimaryButton
            type="submit"
            onClick={this.store.submit}
            disabled={!this.store.canSubmit}
          >
            {locale.Save}
          </PrimaryButton>
        </DialogActions>
      </Dialog>
    );
  }
}

export default CallListEditorDialog;
